<template lang="html">
  <v-navigation-drawer
    v-model="abrirMenu"
    app
    temporary
    style="overflow: hidden"
    width="300"
    class="SideBar__Menu">

    <div>
      <div class="imagem_menu">
        <img :src="logo" alt="">
      </div>
    </div>

    <v-list style="height: 76vh; overflow-y: auto;" class="listaMenu">
      <template v-for="item in menuList">
        <v-list-group
          v-if="item.sub"
          v-model="item.model"
          :key="item.text"
          :prepend-icon="item.icon"
          no-action
        >
          <v-list-item slot="activator">
            <v-list-item-content>
              <v-list-item-title class="black-text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(child, i) in item.sub"
            :key="i"
            @click="goToPage(child.route)"
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="black-text">
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" @click="goToPage(item.route)">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="black-text">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <v-footer class="footer" inset style="margin-top: 13px;">
      <span>Tradelinks</span>
    </v-footer>

  </v-navigation-drawer>
</template>

<script type="text/javascript">
import { showLoading, hideLoading } from '../../common/functions/loading';

export default {
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      },
    },
    abrir: false,
    logo: String,
  },
  data() {
    return {
      abrirMenu: false,
      rotaAtual: null,
    };
  },
  watch: {
    abrir() {
      this.abrirMenu = !this.abrirMenu;
    },
  },
  methods: {
    lockBodyScroll() {
      document.body.style.overflowY = 'hidden';
    },
    onItemClicked(item) {
      if (!item.sub) {
        this.goToPage(item.route);
      }
    },
    getAbsolutePath() {
      return window.location.hash ? window.location.hash.replace('#/', '') : '';
    },
    shouldReloadRoute(route) {
      const { current } = this.$router.history;
      return current.matched.filter((m) => m.name === route).length > 0;
    },
    goToPage(route) {
      this.abrirMenu = !this.abrirMenu;
      if (this.$route.name === route && this.$route.name !== 'importacoes') {
        return;
      }

      setTimeout(() => {
        if (!this.shouldReloadRoute(route)) {
          showLoading();
          this.$router
            .push({ name: route, params: { menu: true } }, null, () => hideLoading());
        } else {
          this.$router.go();
        }
      }, 500);
    },
    toggleLockBodyScroll() {
      document.body.style.overflowY = document.body.style.overflowY === 'hidden'
        ? 'auto'
        : 'hidden';
    },
    unlockBodyScroll() {
      document.body.style.overflowY = 'auto';
    },
    toggleExpand(...args) {
      $logger.log('Args', args);
    },
    resetSidebar() {
      this.rotaAtual = null;
    },
  },
  mounted() {
    $logger.log('Mounting', 'Sidebar');
  },
};
</script>

<style src="./Sidebar.scss" lang="scss"></style>
<style lang="scss">
  @import '~@/config/theme/theme.scss';
  .imagem_menu {
    padding: 10px;
    height: 18vh;
    max-height: 6vw !important;
    min-height: 6em !important;
  }
  .imagem_menu img {
    height: 15vh !important;
    max-height: 5vw !important;
    min-height: 5em !important;
    margin: auto;
    display: block;
  }
  .black-text {
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .footer {
    color: $primary-color !important;
  }
  .listaMenu .v-list-group__header__prepend-icon {
    justify-content: center;
  }
  .v-application--is-ltr .v-list-group--no-action>.v-list-group__items>div>.v-list-item {
    padding-left: 3em;
  }
  .SideBar__Menu .v-list-group .v-list-group__header .v-list-item {
    padding-left: 0px;
  }
  .v-list-item__action .fa {
    padding-left: 0.2em;
  }
</style>
